import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { ProMenu } from '@fle-ui/pro-layout';
import commonStore from '../../stores/common';
import Cookies from 'js-cookie';
import ConsoleHeader from '@fle-ui/pro-console-header';
import { Modal } from '@fle-ui/next';
import BasicRouter from './router';

import { YUN_YING_MAIN_HOST as ORIGIN, BASE_ROUTER } from '../../config';

import baseRouterConfig from '../../config/router/base';

import { AppRoute, AppRouter } from '@ice/stark';
import Loading from '../../components/Loading';
import ProResult from '@fle-ui/pro-result';

import _ from 'lodash';

const CommonRouteConfig = {
	sandbox: true,
	umd: true,
	// FIXME: cached
	cached: false
};
// url 正则
const Basic = () => {
	const history = useHistory();
	const [userInfo, setUserInfo] = React.useState({});
	const [selectKey, setSelectKey] = useState([-1]);

	const getmemberInfo = useCallback(async () => {
		let userInfo = {};
		try {
			userInfo = JSON.parse(window.localStorage.getItem('userInfo')) || {};
			setUserInfo({
				id: userInfo.outUserId,
				name: userInfo.userName
			});
		} catch (ex) {
			console.warn(ex);
		}
	}, [history]);

	useEffect(() => {
		getmemberInfo().finally();
	}, [getmemberInfo]);

	useEffect(() => {
		getRouterConfig();
	}, []);

	const getRouterConfig = () => {
		let thisIndex = [-1];

		baseRouterConfig.forEach((item, index) => {
			if (window.location.pathname.startsWith(`${BASE_ROUTER}${item.path}`)) {
				thisIndex = [index];
			}
		});

		setSelectKey(thisIndex);
	};

	const handleLoginOut = async () => {
		Cookies.remove('supplier_token');
		Modal.confirm({
			title: '是否确认登出？',
			onOk() {
				commonStore.logout().then(() => {
					history.push('/login');
				});
			}
		});
	};
	const handleTopMenu = (info) => {
		history.push(info.key);
	};
	const onAppLeave = () => {
		window.webpackJsonp = [];
	};

	const handleLeftMenuApply = (info) => {
		if (info.type === 'link') {
			// window.open(info.path)
			location.href = info.path;
		} else {
			history.push(info.path);
			setSelectKey([info.index]);
		}
	};

	const commonProps = { id: 'fx-operate-admin' };

	return (
		<>
			{!window.__POWERED_BY_WUJIE__ && (
				<>
					<ProMenu
						styleType="left"
						onLeftMenuApply={handleLeftMenuApply}
						defaultSelectedKey={selectKey}
						appProps={{
							icon: 'https://qa-yunying.fxqifu.com/panguOperate/favicon.ico'
						}}
						leftMenuItems={baseRouterConfig}
					/>

					<ConsoleHeader
						userApplyName="盘古中台"
						isLoading={false}
						userInfo={userInfo}
						sliderInfo={null}
						onExit={handleLoginOut}
						fastApply={[]}
						theme="light"
						isFixed
						style={{ left: 64, transition: '0.2s all', width: 'auto', height: 60 }}
					/>
				</>
			)}

			<AppRouter
				LoadingComponent={Loading}
				onAppLeave={onAppLeave}
				ErrorComponent={<ProResult type="loadingFail" />}
				NotFoundComponent={<ProResult type="404" />}
				shouldAssetsRemove={() => false}
			>
				<AppRoute {...CommonRouteConfig} path="/panguOperate/module/order" entry={`${ORIGIN}order`} />
				<AppRoute {...CommonRouteConfig} path="/panguOperate/module/trading" entry={`${ORIGIN}trading`} />
				<AppRoute {...CommonRouteConfig} path="/panguOperate/module/role" entry={`${ORIGIN}role`} />

				<AppRoute {...CommonRouteConfig} path="/panguOperate/module/cms/" entry={`${ORIGIN}cms`} props={commonProps} />
				<AppRoute {...CommonRouteConfig} path="/panguOperate/module/intelligent/" entry={`${ORIGIN}intelligent`} props={commonProps} />
				<AppRoute {...CommonRouteConfig} path="/panguOperate/module/operateSupplier/" entry={`${ORIGIN}operateSupplier`} props={commonProps} />

				<AppRoute
					path="*"
					umd={false}
					render={() => {
						return (
							<section className="main-route-wrap">
								<BasicRouter />
							</section>
						);
					}}
				/>
			</AppRouter>
		</>
	);
};

export default observer(Basic);
